export default __webpack_public_path__ + "static/media/Snd_03.a011595f.mp3";